module.exports = __webpack_public_path__ + "img/masterCard.05c5498a.svg";